

enum MemberValidationState {
    Invalid = 0,
    PersonValid = 1,
    EmailValid = 2,
    PhoneValid = 4,
    EmailPending = 8,
    PhonePending = 16,
    EmailExpired = 32,
    PhoneExpired = 64,

    EmailValidAndPending = EmailPending | EmailValid,
    PhoneValidAndPending = PhonePending | PhoneValid,

    Valid = PersonValid | EmailValid | PhoneValid,
}

interface MemberValidation {
    state: MemberValidationState;
    email: string;
    phone: string;
    code: string;
}

const MemberValidationDefaults: MemberValidation = {
    state: MemberValidationState.Invalid,
    email: null,
    phone: null,
    code: null,
}

export {
    MemberValidationState,
    MemberValidation,
    MemberValidationDefaults,
}